import React, { useState } from 'react'
import { Faq } from '../../api/Types'

interface Props {
  readonly faq: Faq
  readonly isActive?: boolean
  readonly handleOnClick?: Function | null
}

const FaqsEntry: React.FunctionComponent<Props> = ({ faq, isActive, handleOnClick }) => {
  const [showAnswer, toggleShowAnswer] = useState(isActive || false)

  const toggleAnswer = () => {
    // if prop `isActive` is missing, this component
    // is responsible for its own state.
    if (isActive === undefined || isActive === null) {
      toggleShowAnswer(!showAnswer)
    }
    if (typeof handleOnClick === 'function') {
      toggleShowAnswer(prevshowAnswer => (prevshowAnswer && !isActive ? showAnswer : !showAnswer))
      handleOnClick(faq.id)
    }
  }
  return (
    <div className={'faqs-entry' + (showAnswer && isActive ? ' open' : '')}>
      <button className='faqs-entry-question' onClick={toggleAnswer}>
        <span className='faqs-entry-question-text'>{faq.question}</span>
        <span className='faqs-entry-question-chevron'></span>
      </button>
      <div className='faqs-entry-answer' dangerouslySetInnerHTML={{ __html: faq.answer }}></div>
    </div>
  )
}

export default FaqsEntry
